import React, { useEffect, useState } from "react";
import Select, { components, DropdownIndicatorProps, GroupBase } from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faChevronDown, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { library, icon, toHtml } from "@fortawesome/fontawesome-svg-core";
import { useNavigate } from "react-router-dom";
import styles from "./DisplayEwallets.module.scss";
import eWalletInfo from "../../interfaces/ewallet-info";
import Header from "../../components/Header/Header";
import EWallet from "../../components/EWallet/EWallet";
import customStyles from "../../utils/select-custom-styles";
import GRADES from "../../constants/grades";
import useFindEwallets from "../../hooks/useFindEwallets";
import analyticsService from "../../services/analytics/analyticsService";

library.add(faChevronDown);

function CaretDownIcon() {
  return <FontAwesomeIcon icon="chevron-down" />;
}

function DropdownIndicator(props: & DropdownIndicatorProps<unknown, boolean, GroupBase<unknown>>) {
  return (
    <components.DropdownIndicator {...props}>
      <CaretDownIcon />
    </components.DropdownIndicator>
  );
}

function DisplayEwallets(props: any) {
  const [sort, setSort] = useState(1);
  const [grade, setGrade] = useState("");
  const [eWallets, setEwallets] = useState<eWalletInfo[]>([]);
  const [nameFilter, setNameFilter] = useState("");
  const navigate = useNavigate();
  const dumble = new analyticsService();

  const [findEwallets] = useFindEwallets();
  const getEwallets = async () => {
    const { data, error } = await findEwallets();
    if (error) {
      console.log(`Woops: ${error.message}`);
    } else {
      setEwallets(data);
    }
  };

  const getSVGURI = (faIcon: any) => {
    const abstract = icon(faIcon).abstract[0];
    return `data:image/svg+xml;base64,${btoa(toHtml(abstract))}`;
  };

  const SORTS: any[] = [
    {
      label: "Student Name A-Z",
      value: 1,
    }, {
      label: "Student Name Z-A",
      value: 2,
    }, {
      label: "Teacher Name A-Z",
      value: 3,
    }, {
      label: "Teacher Name Z-A",
      value: 4,
    },
  ];

  useEffect(() => {
    if (props.redirectFunc === "refund"){
      dumble.initDumblePage("Payment Portal:eWallet:Refund Select eWallet");
    } else{
      dumble.initDumblePage("Payment Portal:eWallet:Payment Select eWallet")
    }
  }, [])

  useEffect(() => {
    // get 404 message, else
    getEwallets();
  }, [props.fairId]);

  const redirectToRefund = (event: any, params:any) => {
    event.preventDefault();
    navigate("/ewalletrefund/sales.html", {
      state: {
        amount: params.amount,
        grade: params.grade,
        id: params.id,
        studentFirstName: params.studentFirstName,
        studentLastName: params.studentLastName,
        teacherFirstName: params.teacherFirstName,
        teacherLastName: params.teacherLastName,
        transactions: params.transactions,
      },

    });
  };

  const redirectToAmount = (event: any, params:any) => {
    event.preventDefault();
    navigate("/ewalletpayment/amount.html", {
      state: {
        amount: params.amount,
        grade: params.grade,
        id: params.id,
        studentFirstName: params.studentFirstName,
        studentLastName: params.studentLastName,
        teacherFirstName: params.teacherFirstName,
        teacherLastName: params.teacherLastName,
        transactions: params.transactions,
      },
    });
  };

  const chooseRedirect = (event: any, params: any) => {
    if (props.redirectFunc === "refund") redirectToRefund(event, params);
    else redirectToAmount(event, params);
  };

  return (
    <div className={styles.DisplayEwallets} data-testid="EwalletRefund">
      <Header name={(props.redirectFunc === "refund" ? "eWallet Refund" : "eWallet Payment")} redirect="/" />
      <div className={styles.EWalletWrapper}>
        <div className={styles.bodyContainer}>
          <div className={styles.header}>
            <h1>Select an Ewallet</h1>
          </div>
          <div className={styles.responsive}>
            <div className={styles.inputContainer}>
              <div>Search Name</div>
              <input style={{ backgroundImage: `url(${getSVGURI(faMagnifyingGlass)})` }} className={styles.searchInput} onChange={(e: any) => setNameFilter(e.target.value)} />
            </div>
            <div className={`${styles.dropDown}`}>
              Grade
              <Select
                options={GRADES}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator,
                }}
                className={styles.selectionInput}
                styles={customStyles}
                placeholder="Choose"
                onChange={(e: any) => setGrade(e.value)}
              />
            </div>
            <div className={styles.dropDown}>
              Sort By
              <Select
                options={SORTS}
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator,
                }}
                className={styles.selectionInput}
                styles={customStyles}
                placeholder="Student Name A-Z"
                onChange={(e: any) => {
                  setSort(e.value);
                  console.log("e: ", e);
                }}
              />
            </div>
          </div>
        </div>
        <div className={styles.EwalletList}>
          {
            // first comparison (sort % 2) checks if we're sorting in reverse or not
            /// / sort = 2 or sort = 4 is student and teacher Z->A sort, respectively
            /// / this means when sort % 2 = 0, we know to reverse the sort
            // second comparison (sort < 3) checks if we're sorting by student or teacher names
            /// / sort = 1 & 2 are for student names, and sort = 3 & 4 are teacher names
              eWallets.sort((a, b) => (sort % 2 ? sort < 3
                ? a.studentLastName.localeCompare(b.studentLastName)
                : a.teacherLastName.localeCompare(b.teacherLastName)
                : sort < 3
                  ? b.studentLastName.localeCompare(a.studentLastName)
                  : b.teacherLastName.localeCompare(a.teacherLastName)))

                .filter((item) => 
                (item.grade.toLowerCase() === grade || grade === "" || grade === "All Grades")
                //   // we check to see if nameFilter is empty. if it is, we can ignore filtering
              //   // if it's not we check to see if first name, last name or a combination of both
              //   // contains the substring, regardless of case
              && (nameFilter === "" ? true
                : item.studentFirstName.concat(" ", item.studentLastName, " ", item.teacherFirstName, " ", item.teacherLastName)
                  .toLowerCase().includes(nameFilter.toLowerCase())))
                .map((item, index) => (
                  <button
                    type="submit"
                    id={`ewallet${index}`}
                    onClick={
                      (e) => chooseRedirect(e, item)}>
                    <EWallet item={item} payment={true}/>
                  </button>
                  
                ))
              }
        </div>
      </div>
    </div>
  );
}

export default DisplayEwallets;
